'use es6';

import PropTypes from 'prop-types';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function MenuTreePreview({
  parentId,
  menuId,
  nodes,
  getMenuComponent,
  depth,
  marginBlockStart = '0'
}) {
  const menuTreeMarginInlineStart = parentId ? '600' : '0';
  const MenuComponent = getMenuComponent(false);
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockStart: marginBlockStart,
    marginInlineStart: menuTreeMarginInlineStart,
    children: nodes.map((node, index) => /*#__PURE__*/_jsx(MenuComponent, Object.assign({
      parentId: parentId,
      getMenuComponent: getMenuComponent
    }, node, {
      depth: depth,
      index: index,
      menuId: menuId
    }), node.id))
  });
}
MenuTreePreview.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  nodes: PropTypes.arrayOf(PropTypes.object),
  getMenuComponent: PropTypes.func.isRequired,
  depth: PropTypes.number.isRequired,
  className: PropTypes.string
};
export default MenuTreePreview;